export default __webpack_public_path__ + "static/media/app.4e53622c.png";